module.exports = __webpack_public_path__ + "static/img/1.e929cd5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/1.png
// module id = dMdZ
// module chunks = 0